import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_331 implements Validator {

    public static id = 'CTRL_331';
    private message = 'error.ctr_331';


    public LOG: LogService = new LogService(CTRL_331);

    validate(form: any, map) {


        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_331.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const montantIndefiniNameWithStepId = map.get(ctrl.value.rgCtrls.montantIndefini);
                const montantIndefiniCtrl = form.controls[montantIndefiniNameWithStepId];
                const valeurNameWithStepId = map.get(ctrl.value.rgCtrls.valeur);
                const valeurCtrl = form.controls[valeurNameWithStepId];
                const monnaieNameWithStepId = map.get(ctrl.value.rgCtrls.monnaie);
                const monnaieCtrl = form.controls[monnaieNameWithStepId];
                const offreBasseNameWithStepId = map.get(ctrl.value.rgCtrls.offreBasse);
                const offreBasseCtrl = form.controls[offreBasseNameWithStepId];
                const offreEleveeNameWithStepId = map.get(ctrl.value.rgCtrls.offreElevee);
                const offreEleveeCtrl = form.controls[offreEleveeNameWithStepId];
                const monnaieFourchetteNameWithStepId = map.get(ctrl.value.rgCtrls.monnaieFourchette);
                const monnaieFourchetteCtrl = form.controls[monnaieFourchetteNameWithStepId];

                let filled = 0;
                if (!this.isEmpty(valeurCtrl, false) && !this.isEmpty(monnaieCtrl, false)) filled++;
                if (!this.isEmpty(offreBasseCtrl, false) && !this.isEmpty(offreEleveeCtrl, false) && !this.isEmpty(monnaieFourchetteCtrl, false)) filled++;
                if (!this.isEmpty(montantIndefiniCtrl, true)) filled++;

                if (filled != 1) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }

    public isEmpty(ctrl, isBoolean) {
        return ctrl == undefined || ctrl == null || ctrl.value == undefined || ctrl.value == null || ctrl.value == '0' || (!isBoolean && ctrl.value == '');
    }
}